// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"213":"imprint","563":"content"}[chunkId] + "." + {"213":"c82be3d3","563":"ee8c40e6"}[chunkId] + ".css";
};